module.exports = __webpack_public_path__ + "static/media/mycart_product7.0b5726b7.png";